import { PaginatedRequest } from '../types/api';
import {
  CreateCompanyAddressRequest,
  CreateCompanyAddressResponse,
  FetchCompanyAddressesResponse,
  UpdateCompanyAddressRequest,
  UpdateCompanyAddressResponse,
} from '../types/companyAddress';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class CompanyAddressService extends ApiService {
  pathname = 'admin/thrift-company-addresses';

  fetchCompanyAddresses = async (companyId: number, data: PaginatedRequest) =>
    this.get<FetchCompanyAddressesResponse>(`${this.pathname}/company/${companyId}?${toQueryParams(data)}`);

  createCompanyAddress = async (companyId: number, data: CreateCompanyAddressRequest) =>
    this.post<CreateCompanyAddressResponse, CreateCompanyAddressRequest>(`${this.pathname}/company/${companyId}`, data);

  updateCompanyAddress = async (
    companyId: number,
    id: number,
    data: Omit<UpdateCompanyAddressRequest, 'id' | 'companyId'>,
  ) =>
    this.put<UpdateCompanyAddressResponse, Omit<UpdateCompanyAddressRequest, 'id' | 'companyId'>>(
      `${this.pathname}/company/${companyId}/${id}`,
      data,
    );

  deleteCompanyAddress = async (companyId: number, id: number) =>
    this.delete<CreateCompanyAddressResponse>(`${this.pathname}/company/${companyId}/${id}`);
}

export const companyAddressService = new CompanyAddressService();
